import { Box } from "@mui/material";
import { ForwardedRef, forwardRef, PropsWithChildren, type JSX } from "react";

type HeaderButtonProps = {
    onClick?: () => void;
}

function HeaderButton({
    onClick,
    children
}: PropsWithChildren<HeaderButtonProps>, ref: ForwardedRef<HTMLDivElement>): JSX.Element {

    function onButtonClick(event: React.MouseEvent<HTMLDivElement>) {
        onClick && onClick();
        event.stopPropagation();
    }

    return (
        <Box
            ref={ref}
            onClick={onButtonClick}
            sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center"
            }}
        >
            {children}
        </Box>
    );
}

export default forwardRef(HeaderButton);